<script>
  import { _ } from 'svelte-i18n'
  import { modals, user, user_valid, user_subscription, pro_yearly_sale_details } from '../stores'
  import { logOutUser } from '../services/user'
  import Dropdown from '../elements/Dropdown.svelte'

  let payment_overdue = false
  
  $: account_expiring = $user.expiring && !$user_subscription && $user_valid
  $: discount_percent = Math.ceil($pro_yearly_sale_details?.discountPercent) || '33'
  $: pro_or_business = $user_subscription.product.toLowerCase().includes('pro') ? $_('app.proName') : $_('app.businessName')

  $: if($user_subscription) {
    if ($user_subscription.state === "overdue") {
      payment_overdue = true
    }
  }

</script>

<Dropdown 
  trigger_text={$user.first_name} 
  notification={!$user_valid || payment_overdue || account_expiring}
  button_on_fill={true}>

  <small>{$_('app.loggedInAs')}</small><br>
  {$user.first_name}&nbsp;{$user.last_name}<br>
  {$user.email}
  <hr>

  {#if !$user_valid}
    <div 
    class="expired" 
    class:sale_badge={!!$pro_yearly_sale_details} 
    data-sale-text={!!$pro_yearly_sale_details ? `${discount_percent}% ${$_('subscriptionPlan.sale')}` : ""}>
      <small>{$_('subscriptionPlan.subscriptionExpired')}</small>
      <br>
      <!-- svelte-ignore a11y-invalid-attribute -->
      <a href="#" on:click|preventDefault={() => modals.open('buy')}>
        {$_('subscriptionPlan.subscribeAgain')}
      </a>
    </div>
    <hr>
  {/if}
  
  {#if account_expiring}
    <div class="expired" class:sale_badge={!!$pro_yearly_sale_details}>
      <small>{@html $user.expired ? $_('app.expired') : $_('app.expiresIn', {values: {days_to_expire: $user.days_to_expire}})}</small>
      <br>
      <!-- svelte-ignore a11y-invalid-attribute -->
      <a href="#" on:click|preventDefault={() => modals.open('buy')}>
       {$_('buttons.subscribe')}
      </a>
    </div>
    <hr>
  {/if}
  
  <!-- svelte-ignore a11y-invalid-attribute -->
  <a class="mb" class:payment_overdue href="#" on:click|preventDefault={() => modals.open('accountInfo')}>
    {$_('user.accountInfo')}
  </a>
  
  <!-- svelte-ignore a11y-invalid-attribute -->
  <a class="mb" href="#" on:click|preventDefault={() => modals.open('loadSelection')}>
    {$_('buttons.manageSavedSelections')}
  </a>
  
  <!-- svelte-ignore a11y-invalid-attribute -->
  <a href="#" on:click|preventDefault={() => modals.open('manageUploadedFonts')}>
    {$_('buttons.manageUploadedFonts')}
  </a>
  
  <hr>
  <!-- svelte-ignore a11y-invalid-attribute -->
  <a href="#" on:click|preventDefault={() => logOutUser(true)}>
    {$_('buttons.logout')}
  </a>

</Dropdown>

<style>
  hr {
    margin: 1.5rem -1.5rem 1.5rem;
  }
  a {
    color: var(--c-text);
    text-decoration: none;
    display: block;
  }
  a:hover {
    color: var(--c-accent);
  }
  .expired {
    position: relative;
    margin: -1.5rem -1.7rem;
    padding: 1rem 2rem;
    background-color: var(--c-accent-orange);
    border-bottom: 1px solid var(--c-button-ol);
  }
  .expired small {
    color: var(--c-text-on-fill-hover);
    letter-spacing: 0;
  }
  .expired a {
    color: var(--c-text-on-fill-hover);
    text-decoration: underline;
  }
  .expired a:hover {
    text-decoration: none;
  }
  .expired.sale_badge:before {
    content: attr(data-sale-text);
    position: absolute;
    left: 10px;    
    top: -10px;
    transform: rotate(-5deg);
    color: white;
    font-weight: bold;
    font-size: 13px;
    background-color: red;
    line-height: 20px;
    padding: 0 10px;
    box-shadow: 2px 1px 1px rgb(0 0 0 / 20%);
  }
  .payment_overdue {
    color: var(--c-accent-orange);
  }
  .payment_overdue:after {
    content: "1";
    position: absolute;
    right: 1rem;
    width: 2rem;
    height: 2rem;
    font-size: 1.5rem;
    line-height: 1rem;
    font-weight: bold;
    text-align: center;
    color: var(--c-text-on-fill);
    background-color: var(--c-accent-orange);
    border-radius: 1.5rem;
    border: 3px solid var(--c-content-bg);
  }
  .mb {
    margin-bottom: 1rem;
  }
</style>